import { useMemo, useState } from 'react'
import { useFirestoreQuery } from '../firebase/useFirestore'
import DEFAULT_LETTER_TEMPLATES from '../data/defaultLetterTemplates'
import mergeLetterTemplates from '../helpers/letters/mergeLetterTemplates'

// De brief-sjablonen voor de briefpagina: eerst wat Deccos voor deze organisatie
// klaarzette (LetterTemplates), daarna altijd de standaardbrief — of de eigen
// versie die de organisatie ervan opsloeg (mergeLetterTemplates). Laden ('') en een
// geweigerde lees-actie zijn iets anders dan 'geen eigen sjablonen'; bij een fout
// blijft de standaardbrief bruikbaar en gaat de fout mee. AI-CONTEXT: See docs/pitfalls.md#database-firestore-silent-listener-failure
// AI-CONTEXT: See docs/features/adres-koppeling-algemene-qr.md

/** @returns {{templates: Array<object>, loaded: boolean, error: Error|null}} */
const useLetterTemplates = () => {
    const [error, setError] = useState(/** @type {Error|null} */ (null))
    const docs = useFirestoreQuery('LetterTemplates', { initial: '', onError: setError })

    const templates = useMemo(() => mergeLetterTemplates(docs, DEFAULT_LETTER_TEMPLATES), [docs])

    return { templates, loaded: docs !== '' || Boolean(error), error }
}

export default useLetterTemplates
